import classNames from "classnames";
import * as React from "react";

import styles from "./Badge.module.css";

export type BadgeVariant =
  | "primary"
  | "secondary"
  | "success"
  | "warning"
  | "error"
  | "info"
  | "brand"
  | "label";

export interface BadgeProps {
  /** What the label means, as a color. Defaults to `primary`. */
  variant?: BadgeVariant;
  /** Drawn before the label. */
  icon?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

/**
 * A small label. Use `variant="label"` for a category, such as a device type:
 * outlined, with no icon or tone, so it never reads as a status. A status is
 * a `StatusBadge`; a label that can be clicked or removed is a `Tag`.
 */
export function Badge({
  variant = "primary",
  icon,
  className,
  children,
}: BadgeProps) {
  return (
    <span
      className={classNames(styles.badge, className)}
      data-variant={variant}
    >
      {icon}
      {children}
    </span>
  );
}
